import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { News } from '../models/news.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CategoryNewsService extends BaseService<News> {

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    langId: number = 1;
    API_URL = `${environment.apiUrl}/CategoryNews`;
    API_URLFind = `${environment.apiUrl}/CategoryNews/Find`;
    API_URLGetAll = `${environment.apiUrl}/CategoryNews`;
    API_URLAdd = `${environment.apiUrl}/CategoryNews`;
    API_URLUpdate = `${environment.apiUrl}/CategoryNews`;
    API_URLDelete = `${environment.apiUrl}/CategoryNews`;
    API_URLGetById = `${environment.apiUrl}/CategoryNews`;
    constructor(@Inject(HttpClient) http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);
    }

}
